var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 21,
    height: 21,
    rx: 4.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5007 11.9154H11.9173V16.4987C11.9173 16.7418 11.8207 16.975 11.6488 17.1469C11.4769 17.3188 11.2438 17.4154 11.0007 17.4154C10.7575 17.4154 10.5244 17.3188 10.3525 17.1469C10.1806 16.975 10.084 16.7418 10.084 16.4987V11.9154H5.50065C5.25754 11.9154 5.02438 11.8188 4.85247 11.6469C4.68056 11.475 4.58398 11.2418 4.58398 10.9987C4.58398 10.7556 4.68056 10.5224 4.85247 10.3505C5.02438 10.1786 5.25754 10.082 5.50065 10.082H10.084V5.4987C10.084 5.25558 10.1806 5.02242 10.3525 4.85052C10.5244 4.67861 10.7575 4.58203 11.0007 4.58203C11.2438 4.58203 11.4769 4.67861 11.6488 4.85052C11.8207 5.02242 11.9173 5.25558 11.9173 5.4987V10.082H16.5007C16.7438 10.082 16.9769 10.1786 17.1488 10.3505C17.3207 10.5224 17.4173 10.7556 17.4173 10.9987C17.4173 11.2418 17.3207 11.475 17.1488 11.6469C16.9769 11.8188 16.7438 11.9154 16.5007 11.9154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b1f975eb2cdb37f1461d474b102f2ab5.svg";
export { ForwardRef as ReactComponent };